<template>
    <div class="pageTableUsers">
        <ListTableHeader :text-header="$t('Wersje językowe mailingów')"></ListTableHeader>
        <div class="row">
            <div class="col-12">
                <div class="row mb-3">
                    <div class="col-12 col-sm-6 col-md-5 pr-0 pr-md-3 mb-3 mb-md-0">
                        <treeselect :normalizer="languagesNormalizer"
                                    :placeholder="$t('Wybierz') + `...`"
                                    v-model="firstLang"
                                    required
                                    :noOptionsText="$t('Brak danych')"
                                    :options="languages" class="custom "/>

                    </div>
                    <div class="col-12 col-sm-6 col-md-5 pr-0 pr-md-3 mb-3 mb-md-0  ">
                        <treeselect :normalizer="languagesNormalizer"
                                    :placeholder="$t('Wybierz') + `...`"
                                    v-model="secondLang"
                                    required
                                    :noOptionsText="$t('Brak danych')"
                                    :options="languages" class="custom "/>
                    </div>
                    <div class="col-12 col-md-2 pr-0">
                        <b-button
                                variant="primary"
                                @click="getEmailsPerSelectedLangs()"
                                class="custom h-100"
                                :disabled="firstLang === secondLang"
                                block
                        >{{$t('Zatwierdż')}}
                        </b-button>
                    </div>
                </div>
                <perfect-scrollbar class="scroll-table">
                    <b-table
                            striped
                            :items="elementsFiltered"
                            :fields="fields"
                            :per-page="perPage"
                            :current-page="currentPage"
                            class="custom table-users"
                            :tbody-tr-class="rowClass">
                        <template slot="top-row" class="sub-header">
                            <td :key="key" v-for="(field, key) in fields">
                                <template v-if="[2,0,1].indexOf(key) !== -1">
                                    <div class="d-flex ">
                                        <div class="input-group sm custom search ">
                                            <input type="text"
                                                   :placeholder="$t('Wyszukaj')"
                                                   v-model="filters[field.key]"
                                                   class="form-control sm custom">
                                        </div>
                                    </div>
                                </template>
                            </td>
                        </template>
                        <template slot="HEAD_firstLang.title">
                            {{ $t('Tytuł') + ` ` + firstLangTitle }}
                        </template>
                        <template slot="HEAD_secondLang.title">
                            {{ $t('Tytuł') + ` ` + secondLangTitle }}
                        </template>

                        <template slot="actions" slot-scope="scope">
                            <div class="wrap-ico-btn d-flex justify-content-center align-items-center">
                                <EditButton :route="elementRoute"
                                            :disabled="firstLang === secondLang"
                                            :query="{firstLang: firstLang, secondLang: secondLang}"
                                            :item-id="scope.item.id">
                                </EditButton>
                            </div>
                        </template>
                    </b-table>
                </perfect-scrollbar>
            </div>
        </div>
        <b-row>
            <b-pagination v-show="totalRows > perPage"
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class=" custom"></b-pagination>

        </b-row>
        <confirmDeleteModal></confirmDeleteModal>
    </div>

</template>

<script>
import confirmDeleteModal from '@/components/Modals/ConfirmDeleteModal'
import { mapActions } from 'vuex'
import nonStandartFilterMixin from '@/mixins/nonStandartFilterMixin'
import EditButton from '@/components/Buttons/EditButton'
import ListTableHeader from '@/components/Headers/ListTableHeader'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'adminEmails',
  components: {
    confirmDeleteModal,
    Treeselect,
    EditButton,
    ListTableHeader
  },
  mixins: [nonStandartFilterMixin],
  data () {
    return {
      languagesNormalizer (node) {
        return {
          id: node.id,
          label: node.title
        }
      },
      firstLang: null,
      secondLang: null,
      elementRoute: 'admin.email',
      firstLangTitle: this.$t('Język 1'),
      secondLangTitle: this.$t('Język 2'),
      fields: [
        { key: 'id', label: this.$t('#'), sortable: true },
        { key: 'firstLang.title', label: this.$t('Język 1'), sortable: true },
        { key: 'secondLang.title', label: this.$t('Język 2'), sortable: true },
        { key: 'actions', label: this.$t('Operacje') }
      ],
      elements: []
    }
  },
  methods: {
    ...mapActions(['getLanguages']),
    rowClass (item, type) {
      if (type === 'row-top') {
        return 'sub-header'
      }
      return ''
    },
    getEmailsPerSelectedLangs () {
      if (this.firstLang === this.secondLang) {
        return
      }
      this.$store.dispatch('getEmailsPerSelectedLangs', {
        firstLang: this.firstLang,
        secondLang: this.secondLang
      }).then(resp => {
        this.elements = resp
      })
      let firstLang = this.$store.getters.getLanguagePerId(this.firstLang)
      if (firstLang === undefined || firstLang === null) {
        this.firstLangTitle = this.$t('Język 1')
      } else {
        this.firstLangTitle = firstLang.code
      }

      let secondLang = this.$store.getters.getLanguagePerId(this.secondLang)
      if (secondLang === undefined || secondLang === null) {
        this.secondLangTitle = this.$t('Język 2')
      } else {
        this.secondLangTitle = secondLang.code
      }
    }
  },
  computed: {
    languages () {
      return this.$store.getters.languages
    }
  },
  watch: {
    languages (data) {
      if (data === undefined || data === null || data.length === 0) {
        return
      }
      this.firstLang = data[0].id
      if (data.length > 1) {
        this.secondLang = data[1].id
      }
      this.getEmailsPerSelectedLangs()
    }
  },
  created () {
    this.getLanguages()
  }
}
</script>

<style scoped>

</style>
